import { CustomComponentType } from '@sageworks/dynamic-forms';
import { BeneficialOwnership, PrimaryBorrower, CoBorrower, GuarantorEntity, CoSigner, CreditApplicant, PlaidComponent, CollateralInfo } from '../../components';
export class ComponentCreator {
	constructor(private rootComponent: any) {}

	public createHook() {
		return ({ componentType, schema }: { componentType: string; schema: any }) => this.create(componentType, schema);
	}

	// eslint-disable-next-line max-lines-per-function
	private create(componentType: string, schema: any) {
		let component: any;

		switch (componentType) {
			case CustomComponentType.beneficialOwnershipVue:
				component = this.createBeneficialOwnershipComponent(schema);
				break;
			case CustomComponentType.primaryBorrowerEntity:
				component = new PrimaryBorrower({
					parent: this.rootComponent,
					propsData: {
						componentLabel: schema?.label,
						componentId: schema.id,
						allowAddingEntities: schema.allowAddingEntities ?? false
					}
				});
				break;
			case CustomComponentType.coBorrowerEntity:
				component = new CoBorrower({
					parent: this.rootComponent,
					propsData: {
						componentLabel: schema?.label,
						componentId: schema.id,
						allowAddingEntities: schema.allowAddingEntities ?? false,
						validationConfig: {
							required: schema.validate?.required,
							multiple: schema.allowRepeat
						}
					}
				});
				break;
			case CustomComponentType.guarantorEntity:
				component = new GuarantorEntity({
					parent: this.rootComponent,
					propsData: {
						componentLabel: schema?.label,
						componentId: schema.id,
						allowAddingEntities: schema.allowAddingEntities ?? false,
						validationConfig: {
							required: schema.validate?.required,
							multiple: schema.allowRepeat
						}
					}
				});
				break;
			case CustomComponentType.coSignerEntity:
				component = new CoSigner({
					parent: this.rootComponent,
					propsData: {
						componentLabel: schema?.label,
						componentId: schema.id,
						allowAddingEntities: schema.allowAddingEntities ?? false,
						validationConfig: {
							required: schema.validate?.required,
							multiple: schema.allowRepeat
						}
					}
				});
				break;
			case CustomComponentType.creditApplicantEntity:
				component = new CreditApplicant({
					parent: this.rootComponent,
					propsData: {
						componentLabel: schema?.label,
						componentId: schema.id,
						allowAddingEntities: schema.allowAddingEntities ?? false,
						validationConfig: {
							required: schema.validate?.required,
							multiple: schema.allowRepeat
						}
					}
				});
				break;
			case CustomComponentType.plaid:
				component = new PlaidComponent({
					parent: this.rootComponent,
					propsData: {
						componentId: schema.id,
						addNewBtnLabel: schema?.addAnother === null || schema?.addAnother === '' ? undefined : schema?.addAnother
					}
				});
				break;
			case CustomComponentType.collateralInfo:
				component = new CollateralInfo({
					parent: this.rootComponent,
					propsData: {
						componentLabel: schema?.label,
						componentId: schema.id,
						validationConfig: {
							required: schema.validate?.required,
							multiple: schema.allowRepeat
						}
					}
				});
				break;
		}

		component?.$mount();

		return component;
	}

	private createBeneficialOwnershipComponent(schema: any) {
		return new BeneficialOwnership({
			parent: this.rootComponent,
			propsData: {
				componentId: schema.id,
				addNewBtnLabel: schema?.addAnother === null || schema?.addAnother === '' ? undefined : schema?.addAnother,
				validationConfig: {
					required: schema.validate?.required,
					multiple: schema.allowRepeat
				}
			}
		});
	}
}
